<template>
    <div class="vx-row">
        <div class="vx-col w-full">
            <div class="flex items-center">
                <vs-checkbox :value="value" @input="handleInput">Переводить английские буквы в русскоязычные</vs-checkbox>
                <feather-icon icon="InfoIcon" class="ml-2 cursor-pointer" svg-classes="text-primary" @click="isInfoOpen = true"/>
            </div>
            <vs-popup title="Информация" :active.sync="isInfoOpen">
                <p>При включенном параметре все номера помещений, содержащие буквы английского алфавита, будут переведены в буквы русского алфавита (например, «A» будет заменено на «А», «B» будет заменено на «В», «Y» будет заменено на «У».</p>
                <p><span class="font-semibold">Важно:</span> если в номерах помещений встречаются английские буквы, не имеющие аналогичных русских букв (например, J), то импорт будет произведён с английскими буквами, независимо от того, включён ли данный параметр</p>
            </vs-popup>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TranslitSettings",
        props: {
            value: {
                type: Boolean
            }
        },
        data() {
            return {
                isInfoOpen: false,
            }
        },
        methods: {
            handleInput(value){
                this.$emit('input', value);
            }
        },
    }
</script>
